interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="51"
    height="39"
    viewBox="0 0 51 39"
    fill="none"
  >
    <g clipPath="url(#clip0_487_12139)">
      <path
        d="M48.1256 19.7119H15.7498"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1098 5.1084H0.730347"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.83961 19.7119H0.942139"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.6332 5.1084H42.7357"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.361 0.730469C40.7785 0.730469 42.7394 2.69142 42.7394 5.10884C42.7394 7.52626 40.7785 9.48721 38.361 9.48721C35.9436 9.48721 33.9827 7.52626 33.9827 5.10884C33.9827 2.69142 35.9436 0.730469 38.361 0.730469Z"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2143 15.334C13.6317 15.334 15.5927 17.2949 15.5927 19.7124C15.5927 22.1298 13.6317 24.0907 11.2143 24.0907C8.79689 24.0907 6.83594 22.1298 6.83594 19.7124C6.83594 17.2949 8.79689 15.334 11.2143 15.334Z"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3823 33.8916H1.08459"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.9843 33.8916H33.1354"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.757 29.5166C31.1744 29.5166 33.1354 31.4776 33.1354 33.895C33.1354 36.3124 31.1744 38.2733 28.757 38.2733C26.3396 38.2733 24.3787 36.3124 24.3787 33.895C24.3787 31.4776 26.3396 29.5166 28.757 29.5166Z"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.5034 1.05566C40.9208 1.05566 42.8817 3.01662 42.8817 5.43403C42.8817 7.85145 40.9208 9.81241 38.5034 9.81241C36.086 9.81241 34.125 7.85145 34.125 5.43403C34.125 3.01662 36.086 1.05566 38.5034 1.05566Z"
        stroke={color}
        strokeWidth="1.46067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_487_12139">
        <rect width="50.7146" height="39" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
